<div class="field-config-editor">
  <form [formGroup]="configForm">
    <formly-form [form]="configForm" [fields]="translatedConfigFormFields" [model]="field()!"
      [options]="configFormOptions" (modelChange)="onModelChange()"></formly-form>
  </form>

  @if (validationMessage) {
  <div class="validation-message" data-testid="field-editor-validation-message">
    <app-icon name="alert-circle" [size]="14" class="validation-message__icon" />
    <span>{{ validationMessage }}</span>
  </div>
  }
</div>